export default __webpack_public_path__ + "static/media/cases_liang_fu.37417dce.png";